import * as React from "react";
type Props = {
  className?: string,
};
function SvgPolarizing({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Polarizing"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.07 36.1537C31.9571 34.2939 33.117 29.7475 34.5348 25.3045C35.9526 20.8615 37.6797 16.5218 36.9837 12.518C36.3135 8.51409 33.2202 4.84602 29.4566 3.19281C25.6931 1.5396 21.2593 1.90124 18.2434 3.8386C15.2274 5.80179 13.6034 9.31486 12.1856 11.743C10.7679 14.1453 9.55632 15.4628 7.49411 17.5034C5.40613 19.57 2.44171 22.3597 2.9057 24.1163C3.3697 25.8987 7.26212 26.6219 10.1492 28.4818C13.0363 30.3675 14.9438 33.3639 18.2176 35.3013C21.4913 37.2128 26.1571 38.0136 29.07 36.1537Z"
        fill="#CCE0F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6917 10.3318C20.5709 10.0807 19.5738 8.24119 17.6128 8.18591C15.5462 8.12645 14.5717 9.24084 14.0445 9.99763C13.7599 10.4065 13.2356 11.2808 13.0262 11.354C12.8086 11.3408 12.185 10.5822 11.8115 10.2335C11.2817 9.74126 9.83543 8.66092 7.75551 9.57126C5.96303 10.3556 5.44 12.2072 5.39309 12.4819C5.13252 14.0436 5.86405 15.5287 6.89651 16.9562C9.22126 20.1665 13.3926 22.3414 13.9938 22.5118C14.5702 22.7407 14.8495 22.557 15.185 22.3444C15.7159 22.0149 19.5095 18.0722 20.476 15.0477C21.012 13.3712 21.3726 11.7612 20.6917 10.3318Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9549 6.50367C24.9363 6.43751 24.773 5.9482 24.2992 5.85082C23.8 5.7479 23.5157 5.97676 23.3552 6.13794C23.2686 6.22504 23.1039 6.41487 23.0499 6.42367C22.9977 6.41116 22.8787 6.20028 22.803 6.09961C22.6954 5.95741 22.3905 5.63318 21.8465 5.76517C21.3777 5.87887 21.1715 6.30604 21.1483 6.37074C21.0182 6.73877 21.1322 7.13067 21.3218 7.52149C21.7488 8.40049 22.6685 9.10716 22.8072 9.17425C22.9373 9.25452 23.013 9.22186 23.1036 9.1846C23.2466 9.12734 24.3365 8.33244 24.7006 7.63948C24.9025 7.25536 25.0591 6.87988 24.9549 6.50367Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4582 34.0897C31.8689 34.1667 35.5065 30.6531 35.5834 26.2433C35.6241 23.9151 34.6643 21.8023 33.1 20.3142C31.7012 18.9843 29.8194 18.1545 27.737 18.1182C23.3263 18.0412 19.6888 21.5539 19.6118 25.9646C19.5349 30.3743 23.0476 34.0128 27.4582 34.0897ZM22.2333 32.0502L33.3413 20.7488L22.2333 32.0502Z"
        fill="white"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgPolarizing;
